<template>
  <div class="card card-shadow sticky-top">
    <div class="card-header">
      <h1 class="h4">{{ translate('previews.api-call.title') }}</h1>
    </div>
    <div class="card-body p-4">

      <div class="row mb-2"
           v-if="(apiCall.type === 'create-subtest-attempt' || apiCall.type === 'update-subtest-attempt') && apiCall.status === 'error'">
        <div class="col-md-12 justify-content-center">
          <button
            class="btn btn-sm btn-outline-danger"
            @click="recall">
            <span class="fa fa-redo mr-1"></span>RECALL API
          </button>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <ul style="list-style-type: none; padding-inline-start: 0" class="mb-0">
            <li>
              ID: <span class="font-weight-bold">{{ apiCall.id }}</span>
            </li>

            <li v-if="apiCall.student">
              Student: <span class="font-weight-bold">{{ apiCall.student.name + ', ' + apiCall.student.email }}</span>
            </li>

            <li v-if="apiCall.payment">
              Payment: <span class="font-weight-bold">{{ apiCall.payment.type + ', ' + apiCall.payment.amount }}</span>
            </li>

            <li>
              Status: <span class="font-weight-bold">{{ apiCall.status }}</span>
            </li>
          </ul>

          <h3>Request</h3>
          <pre v-if="apiCall.request" style="font-size: 16px;" class="pre-scrollable font-weight-bold"
               v-html="jsonPrettify(apiCall.request)"></pre>

          <h3>Response</h3>
          <pre v-if="apiCall.response" style="font-size: 16px;" class="pre-scrollable font-weight-bold"
               v-html="jsonPrettify(apiCall.response)"></pre>

          <h3>Errors</h3>
          <pre v-if="apiCall.error" style="font-size: 16px;" class="pre-scrollable font-weight-bold"
               v-html="jsonPrettify(apiCall.error)"></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['apiCall'],

  data () {
    return {
      recallForm: new AppForm({
        _token: App.csrfToken,
      })
    };
  },

  methods: {
    jsonPrettify (string) {
      return string.replace(new RegExp(',', 'g'), ', <br /> &nbsp; &nbsp;')
        .replace(new RegExp('}', 'g'), ' <br /> }')
        .replace(new RegExp('{', 'g'), '{ <br /> &nbsp; &nbsp;');
    },

    recall () {
      let self = this;

      App.post('/api/api-calls/' + this.apiCall.id + '/recall', this.recallForm)
        .then(() => {
          self.$parent.$emit('updateApiCalls');
        });
    }
  }
};
</script>

<style>
pre {
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #f36d33;
    color: #666;
    page-break-inside: avoid;
    font-family: monospace;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
}
</style>
